import { apiFetch } from "../../../../services/api-fetch";

class Comment {
  constructor(el) {
    this.element = el;
    this._container = this.element.closest('.comment');
    this._children = this._container.querySelector('.comment__children');

    this._id = this.element.dataset.id;

    this.api = {
      "get": this.element.dataset.apiGet,
      "delete": this.element.dataset.apiDelete
    }
    this.token = {
      "name": this.element.dataset.tokenName,
      "value": this.element.dataset.token
    }
  }

  get id() {
    return this._id;
  }

  get children() {
    return this._children;
  }

  getData() {
    return new Promise((res, rej) => {
      if (!this.api.get) rej("No get method");

      apiFetch(this.api.get, {
        method: "GET"
      }).then(result => {
        res(result);
      }).catch(error => {
        rej(error);
      });
    });
  }

  delete() {
    return new Promise((res, rej) => {
      if (!this.api.delete) rej("No delete method");

      let data = new FormData();

      if (this.token.name) {
        data.append(this.token.name, this.token.value);
      }

      apiFetch(this.api.delete, {
        method: "POST",
        body: data
      }).then(result => {
        let html = result.html ? result.html.trim() : false;
        if (html) this.updateComment(html);
        else this._remove();

        res(result);
      }).catch(error => {
        rej(error);
      });
    })
  }

  updateComment(html) {
    this.element.insertAdjacentHTML('beforeBegin', html);
    this.element.remove();
    this.element = null;
  }

  _remove() {
    this._container.remove();
    this.element = null;
    this.container = null;
  }
}

const getComment = (el) => {
  let comment = el.closest(".comment-entity");

  if (comment) return new Comment(comment);
  return false;
}

export { getComment };